import { useContext } from 'react';

import { HOME_ROUTE } from '../../constants/auth';
import { DEFAULT_PERMISSIONS, DEFAULT_ROUTE_BY_ROLE } from '../../constants/permissions';
import { CompanyContext } from '../../context/company/companyContext';
import { IUserCompany } from '../../interfaces/businessData';

export default () => {
  const { company } = useContext(CompanyContext);

  const companyRole = {
    name: company?.role?.name || '',
    permissions: company?.role?.permissions || DEFAULT_PERMISSIONS,
    defaultRoute: DEFAULT_ROUTE_BY_ROLE[company?.role?.name] || HOME_ROUTE
  };

  const hasAccess = (permissionRequired: string, selectedCompany?: IUserCompany) => {
    if (!permissionRequired) return true;
    const companyData = selectedCompany ?? company;
    const companyPermissions = companyData?.role?.permissions || DEFAULT_PERMISSIONS;

    for (const permission of companyPermissions) {
      if (permissionRequired.startsWith(permission)) {
        return true;
      }
    }

    return false;
  };

  const hasAnyAccess = (permissionsRequired: string[], selectedCompany?: IUserCompany) => {
    if (!permissionsRequired.length) return true;

    for (const permissionRequired of permissionsRequired) {
      if (hasAccess(permissionRequired, selectedCompany)) {
        return true;
      }
    }
    return false;
  };

  return { companyRole, hasAnyAccess };
};
